export const questions = {
  "1. Business Practice (Part 1)": [
    {
      id: 100001,
      question: "According to the Federation of Dental Hygiene Competencies material, which of the following is stated as a purpose of the updated national competencies?",
      options: [
        "Comparing dental hygiene credentials internationally",
        "Setting national salary standards for hygienists",
        "Approving dental hygiene business loans",
        "Certifying dental equipment manufacturers"
      ],
      correctAnswer: 0
    },
    {
      id: 100002,
      question: "What personal characteristics were identified as those of a good office manager?",
      options: [
        "Wealthy, ambitious, competitive, and assertive",
        "Organized, responsible, fair, and a good communicator",
        "Quiet, cautious, reserved, and detail-oriented",
        "Aggressive, persuasive, bold, and confident"
      ],
      correctAnswer: 1
    },
    {
      id: 100003,
      question: "What management skills does a dental hygienist bring to a dental business?",
      options: [
        "Marketing, accounting, legal advising, and sales",
        "Equipment repair, coding, budgeting, and design",
        "Time management, organization, communication, and teamwork",
        "Recruiting, advertising, investing, and auditing"
      ],
      correctAnswer: 2
    },
    {
      id: 100004,
      question: "According to the material, what can help promote a dental business?",
      options: [
        "Discount pricing, aggressive advertising, and long hours",
        "Frequent staff turnover and low overhead costs",
        "Minimal client interaction and quick appointments",
        "Quality care, communication, and a good reputation"
      ],
      correctAnswer: 3
    },
    {
      id: 100005,
      question: "Should an office manager be familiar with dental hygiene practices such as the Process of Care?",
      options: [
        "No, that is only the hygienist's concern",
        "No, managers only handle scheduling and billing",
        "Yes, so appropriate time and resources are provided",
        "Only if the manager is also a hygienist"
      ],
      correctAnswer: 2
    },
    {
      id: 100006,
      question: "Why is time management important in a dental hygiene practice?",
      options: [
        "It helps hygienists finish early every day",
        "It reduces the number of clients seen",
        "It replaces the need for client communication",
        "It helps provide safe, quality, and efficient care"
      ],
      correctAnswer: 3
    },
    {
      id: 100007,
      question: "For whom is time management in a dental practice important?",
      options: [
        "The client, hygienist, dental team, and practice",
        "Only the client and the front desk staff",
        "Only the dentist and office manager",
        "Only the insurance coordinator and lab technician"
      ],
      correctAnswer: 0
    },
    {
      id: 100008,
      question: "Which of the following is NOT listed as a time management skill for dental hygienists?",
      options: [
        "Planning and prioritizing necessary care",
        "Delegating all client care to assistants",
        "Organizing instruments, supplies, and records",
        "Communicating needs with the dental team"
      ],
      correctAnswer: 1
    },
    {
      id: 100009,
      question: "What does \"promotion of oral health\" mean in private practice?",
      options: [
        "Increasing the number of daily appointments",
        "Advertising the practice on social media",
        "Reducing the cost of dental procedures",
        "Helping clients improve health through education"
      ],
      correctAnswer: 3
    },
    {
      id: 100010,
      question: "What does \"the business of oral health\" refer to in private practice?",
      options: [
        "Educating clients about preventive oral care",
        "Diagnosing and treating oral diseases directly",
        "Operating a profitable and sustainable dental practice",
        "Training new dental hygienists on techniques"
      ],
      correctAnswer: 2
    },
    {
      id: 100011,
      question: "Which of these is an example of the \"business\" side of oral health mentioned in the material?",
      options: [
        "Explaining flossing technique to a client",
        "Billing, collecting fees, and controlling expenses",
        "Applying fluoride varnish during a visit",
        "Reviewing a client's medical history"
      ],
      correctAnswer: 1
    },
    {
      id: 100012,
      question: "Who should ultimately determine how much time is needed for a client's dental hygiene care?",
      options: [
        "The dental hygienist, based on client needs",
        "The front desk, based on the calendar",
        "The dentist, based on office policy",
        "The insurance company, based on coverage"
      ],
      correctAnswer: 0
    },
    {
      id: 100013,
      question: "What is the correct order of steps for a 50-minute recare appointment described in the material?",
      options: [
        "Treatment, assessment, history review, then billing",
        "History review, assessment, treatment, then evaluation",
        "Evaluation, treatment, assessment, then scheduling",
        "Assessment, billing, treatment, then history review"
      ],
      correctAnswer: 1
    },
    {
      id: 100014,
      question: "Ethically, what should a hygienist do if care cannot be safely completed in the allotted time?",
      options: [
        "Explain the situation and schedule another appointment",
        "Rush through the remaining procedures quickly",
        "Skip the oral health education portion",
        "Complete only the parts insurance will cover"
      ],
      correctAnswer: 0
    },
    {
      id: 100015,
      question: "According to \"Dentistry as an Enterprise,\" which is listed as a required business criterion?",
      options: [
        "Offer the lowest prices in the region",
        "Employ only licensed specialists on staff",
        "Focus exclusively on cosmetic procedures",
        "Operate efficiently, safely, and create a profit"
      ],
      correctAnswer: 3
    },
    {
      id: 100016,
      question: "Which of the following best describes the \"service concept\" discussed in the material?",
      options: [
        "Offering the widest range of treatments available",
        "Maintaining the lowest appointment wait times",
        "Providing quality care and respecting client needs",
        "Using the newest equipment in every treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 100017,
      question: "How is cultural competency defined in the material?",
      options: [
        "Adapting care to clients' diverse cultural needs",
        "Speaking multiple languages fluently at work",
        "Hiring staff from many different countries",
        "Offering discounts to underserved communities"
      ],
      correctAnswer: 0
    },
    {
      id: 100018,
      question: "How is organizational culture defined in the material?",
      options: [
        "The financial performance and profit margins achieved",
        "The physical layout and design of the office",
        "The attitudes, experiences, beliefs, and values shared",
        "The number of staff employed by a practice"
      ],
      correctAnswer: 2
    },
    {
      id: 100019,
      question: "In a \"power culture,\" how is authority typically distributed?",
      options: [
        "Power is shared equally among all employees",
        "Power rotates between departments each month",
        "Power is determined by client feedback scores",
        "Power is concentrated among a few persons"
      ],
      correctAnswer: 3
    },
    {
      id: 100020,
      question: "What best describes a \"role culture\" in an organization?",
      options: [
        "Employees choose their own responsibilities freely",
        "Authorities are clearly delegated within a structure",
        "Teams form only to solve a single problem",
        "No formal structure or authority exists at all"
      ],
      correctAnswer: 1
    },
    {
      id: 100021,
      question: "What best describes a \"task culture\" in an organization?",
      options: [
        "One leader makes every decision alone",
        "Employees work independently without any teams",
        "Culture is defined by seniority and tenure",
        "Teams are formed to solve particular problems"
      ],
      correctAnswer: 3
    },
    {
      id: 100022,
      question: "What best describes a \"person culture\" in an organization?",
      options: [
        "Employees value the organization above themselves",
        "Individuals believe themselves superior to the organization",
        "Teams collaborate closely on shared problems",
        "Authority is spread evenly among all staff"
      ],
      correctAnswer: 1
    },
    {
      id: 100023,
      question: "What characterizes a \"work hard/play hard\" culture?",
      options: [
        "Few risks are taken, with rapid feedback given",
        "High risks are taken with delayed feedback",
        "No feedback is given on performance ever",
        "Risks are avoided and feedback is rare"
      ],
      correctAnswer: 0
    },
    {
      id: 100024,
      question: "What does a \"process culture\" emphasize?",
      options: [
        "What is achieved rather than how it is done",
        "Only financial outcomes and profit margins",
        "How things are done rather than what is achieved",
        "Only client satisfaction survey results"
      ],
      correctAnswer: 2
    },
    {
      id: 100025,
      question: "What is a \"blame culture\" characterized by?",
      options: [
        "People openly admit and correct their mistakes",
        "People share credit for team successes",
        "People blame each other to avoid reprimand",
        "People rotate responsibility for shared tasks"
      ],
      correctAnswer: 2
    },
    {
      id: 100026,
      question: "What defines a \"multidirectional culture\" in an organization?",
      options: [
        "Minimized communication and cooperation between departments",
        "Maximum communication and cooperation between departments",
        "Strong loyalty to the organization as a whole",
        "Frequent collaboration across all departments"
      ],
      correctAnswer: 0
    },
    {
      id: 100027,
      question: "What describes a \"live and let live\" culture?",
      options: [
        "High cooperation exists, and growth is rapid",
        "Average cooperation exists, but growth is limited",
        "No cooperation exists, and tasks are unfinished",
        "Constant conflict exists, and turnover is high"
      ],
      correctAnswer: 1
    },
    {
      id: 100028,
      question: "What describes a \"leadership enriched\" culture, considered ideal for dental practices?",
      options: [
        "Employees view work as separate from their identity",
        "Employees follow only one leader without question",
        "Employees compete against each other for recognition",
        "Employees view the organization as part of themselves"
      ],
      correctAnswer: 3
    },
    {
      id: 100029,
      question: "According to the material, how can a new employee determine a dental office's organizational culture?",
      options: [
        "By reading the practice's mission statement only",
        "Through a working interview at the practice",
        "By asking clients about their appointment experience",
        "By reviewing the practice's annual financial report"
      ],
      correctAnswer: 1
    },
    {
      id: 100030,
      question: "What are the two main types of dental practices mentioned in the material?",
      options: [
        "Public practice and private practice",
        "Mobile practice and fixed practice",
        "Specialist practice and general practice",
        "Solo practice and group practice"
      ],
      correctAnswer: 3
    },
    {
      id: 100031,
      question: "Which traits are described as belonging to a good leader?",
      options: [
        "Cautious, reserved, detail-oriented, and quiet",
        "Aggressive, competitive, blunt, and demanding",
        "Confident, responsible, supportive, and communicative",
        "Flexible, indifferent, passive, and reactive"
      ],
      correctAnswer: 2
    },
    {
      id: 100032,
      question: "Which traits are described as belonging to a good manager?",
      options: [
        "Organized, responsible, fair, and communicative",
        "Charismatic, visionary, bold, and inspiring",
        "Impulsive, spontaneous, casual, and relaxed",
        "Distant, formal, strict, and unapproachable"
      ],
      correctAnswer: 0
    },
    {
      id: 100033,
      question: "How do a leader's and manager's main roles differ, per the material?",
      options: [
        "Leaders motivate; managers organize daily operations",
        "Leaders schedule; managers motivate the team",
        "Leaders bill clients; managers treat clients",
        "Leaders hire staff; managers fire staff"
      ],
      correctAnswer: 0
    },
    {
      id: 100034,
      question: "How is a mission statement defined in the material?",
      options: [
        "A forward-looking description of future success",
        "A detailed annual budget and expense report",
        "A list of employee job descriptions",
        "A concise explanation of the organization's purpose"
      ],
      correctAnswer: 3
    },
    {
      id: 100035,
      question: "How is a vision statement defined in the material?",
      options: [
        "A concise explanation of current daily operations",
        "A forward-looking description of future success",
        "A record of past organizational achievements",
        "A summary of client satisfaction survey results"
      ],
      correctAnswer: 1
    },
    {
      id: 100036,
      question: "According to the material, a vision statement should describe the organization's state how many years from now?",
      options: [
        "One year from now",
        "Twenty-five years from now",
        "Ten years from now",
        "Six months from now"
      ],
      correctAnswer: 2
    },
    {
      id: 100037,
      question: "Which of the following is listed as a possible member of the dental team?",
      options: [
        "The building's property manager and landlord",
        "The client's family physician and pharmacist",
        "The city's public health inspector",
        "The treatment coordinator and dental lab technician"
      ],
      correctAnswer: 3
    },
    {
      id: 100038,
      question: "What are the \"Five Rs\" of staff management described in the material?",
      options: [
        "Responsibility, respect, rapport, recognition, remuneration",
        "Reliability, review, routine, reward, retention",
        "Recruitment, retention, reporting, review, reward",
        "Respect, routine, reliability, review, retention"
      ],
      correctAnswer: 0
    },
    {
      id: 100039,
      question: "How is \"responsibility\" defined in the Five Rs framework?",
      options: [
        "Managers controlling every employee task closely",
        "Employees following a rigid checklist only",
        "Employees taking ownership instead of being micromanaged",
        "Managers assigning blame when errors occur"
      ],
      correctAnswer: 2
    },
    {
      id: 100040,
      question: "How is \"respect\" defined in the Five Rs framework?",
      options: [
        "Following the office manager's instructions exactly",
        "Valuing team members, their ideas, and expertise",
        "Avoiding disagreement with senior staff members",
        "Limiting communication to formal meetings only"
      ],
      correctAnswer: 1
    },
    {
      id: 100041,
      question: "How is \"rapport\" (relationship) defined in the Five Rs framework?",
      options: [
        "Maintaining strictly professional distance from staff",
        "Competing with coworkers to improve performance",
        "Building strong connections and team cohesiveness",
        "Limiting friendships among dental team members"
      ],
      correctAnswer: 2
    },
    {
      id: 100042,
      question: "How is \"recognition\" defined in the Five Rs framework?",
      options: [
        "Receiving a formal certificate every year",
        "Feeling genuinely valued and appreciated at work",
        "Being promoted after five years of service",
        "Earning the highest salary in the office"
      ],
      correctAnswer: 1
    },
    {
      id: 100043,
      question: "How is \"remuneration\" defined in the Five Rs framework?",
      options: [
        "Verbal praise given during team meetings",
        "Additional unpaid responsibilities for senior staff",
        "Flexible scheduling around personal preferences",
        "Fair compensation and rewards for performance"
      ],
      correctAnswer: 3
    },
    {
      id: 100044,
      question: "What distinguishes \"recognition\" from \"remuneration\" in staff management?",
      options: [
        "Recognition is appreciation; remuneration is fair pay",
        "Recognition is pay; remuneration is appreciation",
        "Both refer only to scheduling flexibility",
        "Both refer only to promotion opportunities"
      ],
      correctAnswer: 0
    },
    {
      id: 100045,
      question: "Dental hygienists need to complete necessary client care within the scheduled appointment time.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100046,
      question: "The five Rs of staff management include recruitment, review, and retention.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100047,
      question: "A working interview can help a new employee determine if a dental practice's culture is a good fit.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100048,
      question: "A power culture distributes authority equally among all employees.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100049,
      question: "A vision statement should be inspirational and describe the organization's future state approximately ten years from now.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1. Business Practice (Part 2)": [
    {
      id: 100050,
      question: "Who conducted (was retained to run) the Healthy and Respectful Workplace Survey on behalf of CDHA?",
      options: [
        "Harry Cummings and Associates Inc.",
        "Statistics Canada",
        "The Conference Board of Canada",
        "Ipsos Public Affairs"
      ],
      correctAnswer: 0
    },
    {
      id: 100051,
      question: "During what time period was the survey conducted?",
      options: [
        "January 5 to February 20, 2018",
        "November 13 to December 17, 2018",
        "March 1 to April 15, 2019",
        "September 10 to October 25, 2017"
      ],
      correctAnswer: 1
    },
    {
      id: 100052,
      question: "How many CDHA members completed the survey?",
      options: [
        "2,150 members",
        "5,400 members",
        "3,780 members",
        "1,890 members"
      ],
      correctAnswer: 2
    },
    {
      id: 100053,
      question: "What percentage of CDHA's total membership did survey respondents represent?",
      options: [
        "8 percent of membership",
        "45 percent of membership",
        "65 percent of membership",
        "22 percent of membership"
      ],
      correctAnswer: 3
    },
    {
      id: 100054,
      question: "How did the geographic distribution of survey responses compare to the overall membership?",
      options: [
        "It came almost entirely from one province",
        "It excluded all territories entirely",
        "It was comparable across provinces and territories",
        "It overrepresented members outside Canada"
      ],
      correctAnswer: 2
    },
    {
      id: 100055,
      question: "How is \"workplace harassment\" defined in the survey?",
      options: [
        "Any disagreement between coworkers at work",
        "Any criticism given during a performance review",
        "Any request made by a supervisor or manager",
        "Objectionable behaviour that offends or degrades"
      ],
      correctAnswer: 3
    },
    {
      id: 100056,
      question: "How is \"workplace bullying\" defined in the survey?",
      options: [
        "Repeated, unreasonable behaviour asserting power",
        "A single comment made in a group meeting",
        "Constructive feedback shared during training",
        "A disagreement resolved through mediation"
      ],
      correctAnswer: 0
    },
    {
      id: 100057,
      question: "How is \"workplace abuse/violence\" defined in the survey?",
      options: [
        "Conduct that merely causes minor inconvenience",
        "Conduct causing or likely to cause injury",
        "Conduct limited to written complaints only",
        "Conduct that occurs only outside work hours"
      ],
      correctAnswer: 1
    },
    {
      id: 100058,
      question: "What percentage of all respondents experienced some form of mistreatment in the past year?",
      options: [
        "15 percent of all respondents",
        "55 percent of all respondents",
        "75 percent of all respondents",
        "35 percent of all respondents"
      ],
      correctAnswer: 3
    },
    {
      id: 100059,
      question: "What percentage of respondents experienced mistreatment from dentists over their career?",
      options: [
        "28 percent of respondents",
        "36 percent of respondents",
        "42 percent of respondents",
        "49 percent of respondents"
      ],
      correctAnswer: 2
    },
    {
      id: 100060,
      question: "What percentage of respondents experienced mistreatment from office managers over their career?",
      options: [
        "22 percent of respondents",
        "36 percent of respondents",
        "42 percent of respondents",
        "49 percent of respondents"
      ],
      correctAnswer: 1
    },
    {
      id: 100061,
      question: "What percentage of respondents experienced mistreatment from co-workers over their career?",
      options: [
        "37 percent of respondents",
        "19 percent of respondents",
        "42 percent of respondents",
        "53 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100062,
      question: "What percentage of respondents experienced mistreatment from clients over their career?",
      options: [
        "31 percent of respondents",
        "49 percent of respondents",
        "37 percent of respondents",
        "42 percent of respondents"
      ],
      correctAnswer: 1
    },
    {
      id: 100063,
      question: "In the past year, what percentage of respondents experienced harassment or bullying from dentists?",
      options: [
        "21 percent of respondents",
        "12 percent of respondents",
        "32 percent of respondents",
        "40 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100064,
      question: "In the past year, what percentage of respondents experienced harassment or bullying from clients?",
      options: [
        "19 percent of respondents",
        "23 percent of respondents",
        "42 percent of respondents",
        "32 percent of respondents"
      ],
      correctAnswer: 3
    },
    {
      id: 100065,
      question: "Which source of mistreatment had the highest percentage of respondents reporting career-long mistreatment?",
      options: [
        "Dentists, at 42 percent of respondents",
        "Co-workers, at 37 percent of respondents",
        "Clients, at 49 percent of respondents",
        "Office managers, at 36 percent of respondents"
      ],
      correctAnswer: 2
    },
    {
      id: 100066,
      question: "What percentage of respondents observed others being mistreated by dentists?",
      options: [
        "49 percent of respondents",
        "36 percent of respondents",
        "40 percent of respondents",
        "41 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100067,
      question: "What percentage of respondents observed others being mistreated by office managers?",
      options: [
        "41 percent of respondents",
        "42 percent of respondents",
        "40 percent of respondents",
        "49 percent of respondents"
      ],
      correctAnswer: 2
    },
    {
      id: 100068,
      question: "What percentage of respondents observed others being mistreated by co-workers?",
      options: [
        "36 percent of respondents",
        "40 percent of respondents",
        "49 percent of respondents",
        "41 percent of respondents"
      ],
      correctAnswer: 3
    },
    {
      id: 100069,
      question: "What percentage of respondents observed others being mistreated by clients?",
      options: [
        "36 percent of respondents",
        "42 percent of respondents",
        "40 percent of respondents",
        "41 percent of respondents"
      ],
      correctAnswer: 1
    },
    {
      id: 100070,
      question: "What was the most common action taken by respondents who experienced mistreatment?",
      options: [
        "Discussing the matter with a lawyer",
        "Filing a formal police report",
        "Contacting a professional regulatory body",
        "Discussing the matter with a co-worker"
      ],
      correctAnswer: 3
    },
    {
      id: 100071,
      question: "What was the second most common action taken in response to mistreatment?",
      options: [
        "Discussing the matter with a family member",
        "Discussing the matter with a manager",
        "Posting about the incident online",
        "Contacting a labour union representative"
      ],
      correctAnswer: 1
    },
    {
      id: 100072,
      question: "What percentage of respondents discussed mistreatment directly with the offending person?",
      options: [
        "46 percent of respondents",
        "53 percent of respondents",
        "65 percent of respondents",
        "32 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100073,
      question: "What percentage of respondents either lack a workplace harassment policy or are unsure if one exists?",
      options: [
        "40 percent of respondents",
        "70 percent of respondents",
        "60 percent of respondents",
        "22 percent of respondents"
      ],
      correctAnswer: 2
    },
    {
      id: 100074,
      question: "Of respondents without a clear policy, what portion reported having no policy at all?",
      options: [
        "18 percent reported no policy at all",
        "60 percent reported no policy at all",
        "42 percent reported no policy at all",
        "35 percent reported no policy at all"
      ],
      correctAnswer: 2
    },
    {
      id: 100075,
      question: "What percentage of respondents indicated they do not always report or discuss mistreatment they experience?",
      options: [
        "32 percent of respondents",
        "18 percent of respondents",
        "46 percent of respondents",
        "60 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100076,
      question: "What was the top factor influencing the decision not to report mistreatment?",
      options: [
        "Concern about losing client trust",
        "Concern about possible retaliation",
        "Concern about extra paperwork",
        "Concern about disappointing coworkers"
      ],
      correctAnswer: 1
    },
    {
      id: 100077,
      question: "What was the second major factor influencing the decision not to report mistreatment?",
      options: [
        "Concern about scheduling conflicts",
        "Concern about training requirements",
        "Concern about client complaints",
        "Concern about impact on job security"
      ],
      correctAnswer: 3
    },
    {
      id: 100078,
      question: "What percentage of respondents reported experiencing stress due to workplace mistreatment?",
      options: [
        "40 percent of respondents",
        "56 percent of respondents",
        "52 percent of respondents",
        "30 percent of respondents"
      ],
      correctAnswer: 1
    },
    {
      id: 100079,
      question: "What percentage of respondents considered quitting their job due to mistreatment?",
      options: [
        "30 percent of respondents",
        "56 percent of respondents",
        "36 percent of respondents",
        "52 percent of respondents"
      ],
      correctAnswer: 3
    },
    {
      id: 100080,
      question: "What percentage of respondents actually quit their job because of mistreatment?",
      options: [
        "52 percent of respondents",
        "56 percent of respondents",
        "30 percent of respondents",
        "40 percent of respondents"
      ],
      correctAnswer: 2
    },
    {
      id: 100081,
      question: "What percentage of respondents reported a loss of motivation from workplace mistreatment?",
      options: [
        "40 percent of respondents",
        "31 percent of respondents",
        "36 percent of respondents",
        "56 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100082,
      question: "What percentage of respondents reported losing interest in their work?",
      options: [
        "36 percent of respondents",
        "31 percent of respondents",
        "40 percent of respondents",
        "52 percent of respondents"
      ],
      correctAnswer: 0
    },
    {
      id: 100083,
      question: "What percentage of respondents reported losing confidence in their abilities?",
      options: [
        "36 percent of respondents",
        "40 percent of respondents",
        "56 percent of respondents",
        "31 percent of respondents"
      ],
      correctAnswer: 3
    },
    {
      id: 100084,
      question: "What percentage of respondents reported at least one issue with management and leadership?",
      options: [
        "35 percent of respondents",
        "57 percent of respondents",
        "42 percent of respondents",
        "68 percent of respondents"
      ],
      correctAnswer: 1
    },
    {
      id: 100085,
      question: "Which of the following was NOT identified as a management or leadership concern in the survey?",
      options: [
        "Lack of authority and accountability",
        "Lack of transparency and poor communication",
        "Excessive vacation time allowances",
        "Poor people skills among leaders"
      ],
      correctAnswer: 2
    },
    {
      id: 100086,
      question: "Which of the following was identified as a key suggestion for supporting a healthy workplace?",
      options: [
        "Reduce the number of scheduled client appointments",
        "Increase advertising spending for the practice",
        "Eliminate performance evaluations for staff",
        "Establish or strengthen a harassment policy"
      ],
      correctAnswer: 3
    },
    {
      id: 100087,
      question: "Which suggestion involved staffing to support and manage employees?",
      options: [
        "Ensure a skilled human resource official is present",
        "Ensure only dentists handle all personnel matters",
        "Ensure office managers avoid staff meetings",
        "Ensure staff resolve issues without documentation"
      ],
      correctAnswer: 0
    },
    {
      id: 100088,
      question: "As part of its Initial Strategic Actions, what did CDHA commit to developing for members?",
      options: [
        "A mandatory annual membership fee increase",
        "A national dental hygiene licensing exam",
        "A set of tools and resources for members",
        "A public ranking of dental practices"
      ],
      correctAnswer: 2
    },
    {
      id: 100089,
      question: "Who should be contacted for more information about the Healthy and Respectful Workplace initiative?",
      options: [
        "Harry Cummings, survey lead researcher",
        "Donna Wells, manager of professional practice",
        "The CDHA board of directors chair",
        "The provincial regulatory registrar"
      ],
      correctAnswer: 1
    },
    {
      id: 100090,
      question: "According to the footnotes, what term encompasses harassment, bullying, abuse, and violence collectively in this document?",
      options: [
        "The term \"misconduct\"",
        "The term \"noncompliance\"",
        "The term \"mistreatment\"",
        "The term \"malpractice\""
      ],
      correctAnswer: 2
    },
    {
      id: 100091,
      question: "According to the footnotes, who are included in the definition of \"co-workers\" for this survey?",
      options: [
        "Dentists and office managers only",
        "Dental hygienists and dental assistants",
        "Clients and receptionists only",
        "Lab technicians and insurance coordinators"
      ],
      correctAnswer: 1
    },
    {
      id: 100092,
      question: "According to the footnotes, which behaviours are examples of workplace bullying?",
      options: [
        "Offering praise and public recognition",
        "Providing scheduled performance reviews",
        "Delegating tasks during a team meeting",
        "Belittling opinions and spreading rumours"
      ],
      correctAnswer: 3
    },
    {
      id: 100093,
      question: "According to the footnotes, reasonable conduct by a supervisor managing workers is generally considered what?",
      options: [
        "Not considered workplace harassment",
        "Always considered workplace harassment",
        "Always considered workplace bullying",
        "Always considered workplace violence"
      ],
      correctAnswer: 0
    },
    {
      id: 100094,
      question: "The survey found that clients were the source of the highest percentage of career mistreatment reported by respondents.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100095,
      question: "Nearly all respondents reported having a clear workplace harassment policy in place.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100096,
      question: "Concerns about retaliation and job security were the top reasons respondents gave for not reporting mistreatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100097,
      question: "The survey found that workplace mistreatment had little effect on respondents' emotional health or motivation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100098,
      question: "CDHA committed to developing tools and resources to support a healthy and respectful workplace for its members.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1. Business Practice (Part 3)": [
    {
      id: 100099,
      question: "What is the title of the article discussed in the material?",
      options: [
        "Business of Dental Hygiene",
        "Basics of Dental Hygiene",
        "Careers in Dental Hygiene",
        "Ethics of Dental Hygiene"
      ],
      correctAnswer: 0
    },
    {
      id: 100100,
      question: "According to the material, what trend is occurring among dental hygienists across Canada?",
      options: [
        "Leaving the profession in record numbers",
        "Opening their own practices in record numbers",
        "Merging with dental offices in record numbers",
        "Retiring early in record numbers"
      ],
      correctAnswer: 1
    },
    {
      id: 100101,
      question: "Which of the following is listed as an option for independent practice?",
      options: [
        "Starting a dental implant clinic",
        "Starting a dental laboratory business",
        "Starting a mobile dental hygiene practice",
        "Starting an orthodontic specialty clinic"
      ],
      correctAnswer: 2
    },
    {
      id: 100102,
      question: "What does CDHA provide to hygienists considering independent practice?",
      options: [
        "Funding, equipment, staff, and office space",
        "Legal representation, insurance, and loans",
        "Marketing agencies, franchises, and contracts",
        "Tools, courses, resources, and expert advice"
      ],
      correctAnswer: 3
    },
    {
      id: 100103,
      question: "Where can hygienists find more information about independent practice, per the article?",
      options: [
        "cdha.ca/businessplan",
        "cdha.ca/mentorship",
        "cdha.ca/independentpractice",
        "cdha.ca/certification"
      ],
      correctAnswer: 2
    },
    {
      id: 100104,
      question: "Who wrote the personal account included in the article?",
      options: [
        "Donna Wells, RDH",
        "Harry Cummings, RDH",
        "Sandra Lee, RDH",
        "Cindy McQueen, RDH"
      ],
      correctAnswer: 3
    },
    {
      id: 100105,
      question: "What is the name of Cindy McQueen's practice?",
      options: [
        "Roving Dental Hygiene",
        "Bright Smile Dental Hygiene",
        "Community Care Dental Hygiene",
        "Neighbourhood Dental Hygiene"
      ],
      correctAnswer: 0
    },
    {
      id: 100106,
      question: "How long has Cindy McQueen been in practice clinically, according to her account?",
      options: [
        "Almost five years clinically",
        "Almost two years clinically",
        "Almost one year clinically",
        "Almost ten years clinically"
      ],
      correctAnswer: 1
    },
    {
      id: 100107,
      question: "How long has she been \"in\" the practice if preparation time is included?",
      options: [
        "About one year including preparation",
        "About seven years including preparation",
        "About five years including preparation",
        "About three years including preparation"
      ],
      correctAnswer: 3
    },
    {
      id: 100108,
      question: "What does Cindy McQueen say is essential before starting a practice?",
      options: [
        "Buying the most advanced equipment available",
        "Hiring a large administrative staff quickly",
        "Doing your homework on a niche client profile",
        "Offering the lowest prices in the market"
      ],
      correctAnswer: 2
    },
    {
      id: 100109,
      question: "According to Cindy McQueen, what will always be a successful practice builder?",
      options: [
        "Discounted pricing",
        "Referrals",
        "Paid media advertising",
        "Franchise partnerships"
      ],
      correctAnswer: 1
    },
    {
      id: 100110,
      question: "What does Cindy McQueen say happens to marketing before the community sees you as a member?",
      options: [
        "It may be too broad and wasted",
        "It becomes highly targeted and effective",
        "It automatically attracts many new referrals",
        "It requires no further adjustment"
      ],
      correctAnswer: 0
    },
    {
      id: 100111,
      question: "What does Cindy McQueen identify as the most difficult part of starting a practice?",
      options: [
        "Choosing equipment for the clinic",
        "Deciding who your clients truly are",
        "Selecting a convenient location",
        "Setting up the practical office set-up"
      ],
      correctAnswer: 1
    },
    {
      id: 100112,
      question: "According to Cindy McQueen, where does patient retention and referral come from in traditional dental hygiene clinics?",
      options: [
        "A sense of relationship with the provider",
        "The lowest price for services offered",
        "The number of advertisements published",
        "The size of the clinic's waiting room"
      ],
      correctAnswer: 0
    },
    {
      id: 100113,
      question: "How does Cindy McQueen say her clients view her, based on her account?",
      options: [
        "Someone offering a discounted service package",
        "Someone following strict corporate procedures",
        "Someone focused mainly on quick appointments",
        "Someone participating compassionately in their care"
      ],
      correctAnswer: 3
    },
    {
      id: 100114,
      question: "According to Cindy McQueen, what never makes the same impact as participating in a community event?",
      options: [
        "Referral programs",
        "Client testimonials",
        "Media advertisements",
        "Word-of-mouth recommendations"
      ],
      correctAnswer: 2
    },
    {
      id: 100115,
      question: "What advice does Cindy McQueen give about making community contacts?",
      options: [
        "Focus on community, not selling a product",
        "Focus on selling products, not community",
        "Focus only on online advertising campaigns",
        "Focus only on discount promotional offers"
      ],
      correctAnswer: 0
    },
    {
      id: 100116,
      question: "What warning does Cindy McQueen give about simply creating a web page and waiting for calls?",
      options: [
        "The hygienist will quickly attract many new clients",
        "The hygienist will find herself in trouble early",
        "The hygienist will succeed without any marketing",
        "The hygienist will need no further community involvement"
      ],
      correctAnswer: 1
    },
    {
      id: 100117,
      question: "Cindy McQueen advises new independent dental hygienists to think outside the box and avoid presenting themselves as a traditional dental office.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100118,
      question: "According to the article, media advertisements make a bigger impact than participating in community events.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "2. Business Plan": [
    {
      id: 100119,
      question: "According to the comparison chart, what motivates an entrepreneur to start a business?",
      options: [
        "A unique idea or concept",
        "An existing idea or concept",
        "A government grant program",
        "A family business inheritance"
      ],
      correctAnswer: 0
    },
    {
      id: 100120,
      question: "Which orientation is associated with the entrepreneur in the comparison chart?",
      options: [
        "Profit-oriented",
        "Customer-oriented",
        "Competitor-oriented",
        "Investor-oriented"
      ],
      correctAnswer: 1
    },
    {
      id: 100121,
      question: "How is the entrepreneur's emotional state described in the material?",
      options: [
        "Worried, distressed, and passive",
        "Bored, indifferent, and tired",
        "Excited, happy, and passionate",
        "Calm, confident, and relaxed"
      ],
      correctAnswer: 2
    },
    {
      id: 100122,
      question: "What is the entrepreneur's focus, according to the comparison?",
      options: [
        "Focus on competition",
        "Focus on regulation",
        "Focus on automation",
        "Focus on cooperation"
      ],
      correctAnswer: 3
    },
    {
      id: 100123,
      question: "According to the material, which statement describes the entrepreneur's relationship with the company?",
      options: [
        "The company works for the entrepreneur",
        "The entrepreneur owns the company outright",
        "The entrepreneur works for the company",
        "The entrepreneur avoids company tasks"
      ],
      correctAnswer: 2
    },
    {
      id: 100124,
      question: "According to the material, does the entrepreneur delegate tasks or micromanage them?",
      options: [
        "The entrepreneur avoids assigning tasks",
        "The entrepreneur outsources every task",
        "The entrepreneur micromanages tasks",
        "The entrepreneur delegates tasks"
      ],
      correctAnswer: 3
    },
    {
      id: 100125,
      question: "According to the material, does the entrepreneur work smarter or harder?",
      options: [
        "The entrepreneur works smarter",
        "The entrepreneur works harder",
        "The entrepreneur works less overall",
        "The entrepreneur rarely works at all"
      ],
      correctAnswer: 0
    },
    {
      id: 100126,
      question: "Which of the following is listed as a business skill related to managing money?",
      options: [
        "Avoiding all financial record keeping",
        "Managing money, borrowing, and budgeting",
        "Ignoring customer needs entirely",
        "Ignoring inventory management fully"
      ],
      correctAnswer: 1
    },
    {
      id: 100127,
      question: "Which activities are included in \"directing sales and marketing operations,\" per the material?",
      options: [
        "Filing government tax paperwork only",
        "Repairing dental equipment on-site",
        "Reviewing legal contracts exclusively",
        "Identifying customer needs and deciding prices"
      ],
      correctAnswer: 3
    },
    {
      id: 100128,
      question: "Which activities are included in \"managing people,\" per the material?",
      options: [
        "Auditing financial statements only",
        "Designing the company logo",
        "Training and motivating employees",
        "Negotiating supplier contracts"
      ],
      correctAnswer: 2
    },
    {
      id: 100129,
      question: "Which activities are included in \"directing business operations,\" per the material?",
      options: [
        "Formulating the mission statement",
        "Purchasing supplies and managing inventory",
        "Writing the executive summary",
        "Developing the exit strategy"
      ],
      correctAnswer: 1
    },
    {
      id: 100130,
      question: "In the Entrepreneurial Opportunity diagram, which factors describe the entrepreneur?",
      options: [
        "Background, experience, and education",
        "Industry, economy, and regulatory issues",
        "Product, price, and promotion",
        "Strengths, weaknesses, and threats"
      ],
      correctAnswer: 0
    },
    {
      id: 100131,
      question: "In the Entrepreneurial Opportunity diagram, which factors describe the environment?",
      options: [
        "Background, experience, and education",
        "Industry, economy, and regulatory issues",
        "Mission, vision, and objectives",
        "Marketing, sales, and operations"
      ],
      correctAnswer: 1
    },
    {
      id: 100132,
      question: "In the Entrepreneurial Opportunity diagram, what follows \"Business Ideas\" in the flow?",
      options: [
        "Entrepreneurial opportunity",
        "Financial forecasts",
        "Executive summary",
        "Exit strategy"
      ],
      correctAnswer: 0
    },
    {
      id: 100133,
      question: "According to the material, recognizing an opportunity involves perceiving a possibility for what?",
      options: [
        "A government subsidy program only",
        "A guaranteed bank loan approval",
        "A mandatory training certificate",
        "A new profitable business or improvement"
      ],
      correctAnswer: 3
    },
    {
      id: 100134,
      question: "Which of the following is listed as a source for generating business ideas from previous employment?",
      options: [
        "Random guessing without research",
        "Copying a competitor exactly",
        "Special skills or specialized knowledge",
        "Ignoring your past work experience"
      ],
      correctAnswer: 2
    },
    {
      id: 100135,
      question: "After generating and evaluating business ideas, what is the final step shown in the diagram?",
      options: [
        "Identifying potential entrepreneurial opportunities",
        "Filing for business incorporation immediately",
        "Hiring a full management team",
        "Publishing a marketing newsletter"
      ],
      correctAnswer: 0
    },
    {
      id: 100136,
      question: "What is Stage 1 in the process of defining your business idea?",
      options: [
        "Financing your business",
        "Legal considerations",
        "Assessing your entrepreneurial potential",
        "Buying a business or franchise"
      ],
      correctAnswer: 2
    },
    {
      id: 100137,
      question: "What is Stage 5 in the process of defining your business idea?",
      options: [
        "Market and technical feasibility",
        "Financial viability",
        "Sales",
        "Business plans"
      ],
      correctAnswer: 3
    },
    {
      id: 100138,
      question: "What is the final stage in the process of defining your business idea?",
      options: [
        "Assessing entrepreneurial potential",
        "Buying a business or a franchise",
        "Defining your business idea",
        "Marketing"
      ],
      correctAnswer: 1
    },
    {
      id: 100139,
      question: "According to the material, why do you need a business plan?",
      options: [
        "To avoid ever changing your idea",
        "To eliminate the need for financing",
        "To replace the need for marketing",
        "To turn ideas and capital into a viable business"
      ],
      correctAnswer: 3
    },
    {
      id: 100140,
      question: "Which of the following is also a reason a business plan is needed, per the material?",
      options: [
        "To avoid hiring any employees",
        "To help secure financing",
        "To eliminate all business risk",
        "To skip market research entirely"
      ],
      correctAnswer: 1
    },
    {
      id: 100141,
      question: "What does a business plan help identify, according to the material?",
      options: [
        "Strengths, weaknesses, threats, and opportunities",
        "Only the company's tax obligations",
        "Only the founder's personal hobbies",
        "Only the office's daily schedule"
      ],
      correctAnswer: 0
    },
    {
      id: 100142,
      question: "How is a business plan defined in the material?",
      options: [
        "A document listing only staff salaries",
        "A document limited to marketing slogans",
        "A document summarizing the business's detailed plans",
        "A document containing only legal contracts"
      ],
      correctAnswer: 2
    },
    {
      id: 100143,
      question: "If a business is growing, how can a business plan help, per the material?",
      options: [
        "To reduce all future opportunities",
        "To discourage further expansion",
        "To raise additional funds",
        "To eliminate the need for strategy"
      ],
      correctAnswer: 2
    },
    {
      id: 100144,
      question: "What is the first step in the business planning process, per the material?",
      options: [
        "Develop a vision statement",
        "Formulate your mission statement",
        "Develop clear and specific objectives",
        "Develop a realistic business plan"
      ],
      correctAnswer: 0
    },
    {
      id: 100145,
      question: "What comes immediately after developing a vision statement in the planning process?",
      options: [
        "Develop a realistic business plan",
        "Formulate your mission statement",
        "Develop clear and specific objectives",
        "Identify potential opportunities"
      ],
      correctAnswer: 1
    },
    {
      id: 100146,
      question: "Which part of the typical business plan is described as the most important part of the plan?",
      options: [
        "The letter of transmittal",
        "The table of contents",
        "The appendices section",
        "The executive summary and fact sheet"
      ],
      correctAnswer: 3
    },
    {
      id: 100147,
      question: "According to the material, what is the purpose of the Letter of Transmittal?",
      options: [
        "To list your complete financial statements",
        "To officially introduce your business plan",
        "To describe your marketing strategy in detail",
        "To outline your exit strategy timeline"
      ],
      correctAnswer: 1
    },
    {
      id: 100148,
      question: "How long should a Letter of Transmittal be, per the material?",
      options: [
        "At least ten to fifteen pages",
        "Exactly one single sentence",
        "A minimum of five full chapters",
        "No more than two to three paragraphs"
      ],
      correctAnswer: 3
    },
    {
      id: 100149,
      question: "How is a mission statement defined in the material?",
      options: [
        "It identifies only the office's street address",
        "It identifies only the company's tax rate",
        "It identifies the purpose, ethics, and culture",
        "It identifies only the founder's biography"
      ],
      correctAnswer: 2
    },
    {
      id: 100150,
      question: "How is a vision statement defined in the material?",
      options: [
        "It identifies the long-term goals of the business",
        "It identifies only last year's revenue figures",
        "It identifies only current staff schedules",
        "It identifies only the office decor"
      ],
      correctAnswer: 0
    },
    {
      id: 100151,
      question: "When should the Executive Summary be written, according to the material?",
      options: [
        "It should be written last",
        "It should be written first",
        "It should be written during Stage 1",
        "It should never be written at all"
      ],
      correctAnswer: 0
    },
    {
      id: 100152,
      question: "How long should the Executive Summary be, per the material?",
      options: [
        "No longer than ten pages",
        "At least twenty pages",
        "Exactly one paragraph only",
        "No longer than two pages"
      ],
      correctAnswer: 3
    },
    {
      id: 100153,
      question: "Which elements should the Business Strategy section include, per the material?",
      options: [
        "Only the office holiday schedule",
        "History, purpose, products, and legal structure",
        "Only the receptionist's job title",
        "Only the parking lot layout"
      ],
      correctAnswer: 1
    },
    {
      id: 100154,
      question: "Which business structures are given as examples in the Business Strategy section?",
      options: [
        "Nonprofit and cooperative only",
        "Government agency and charity",
        "Sole proprietorship and partnership",
        "Public corporation and trust only"
      ],
      correctAnswer: 2
    },
    {
      id: 100155,
      question: "What are the \"Four P's\" of Marketing Strategy listed in the material?",
      options: [
        "Profit, people, process, and paperwork",
        "Plan, pitch, publish, and pursue",
        "Prepare, present, promote, and pay",
        "Product, price, place, and promotion"
      ],
      correctAnswer: 3
    },
    {
      id: 100156,
      question: "How does the material suggest you create a profile of customer types?",
      options: [
        "Using demographics to profile customers",
        "Using astrology to profile customers",
        "Using guesswork to profile customers",
        "Using competitor logos to profile customers"
      ],
      correctAnswer: 0
    },
    {
      id: 100157,
      question: "Which components are listed under the Operational Plan section?",
      options: [
        "Marketing, sales, financing, and exit systems",
        "Vision, mission, objectives, and strategy systems",
        "Facility, management, information, and security systems",
        "Recruitment, training, payroll, and benefits systems"
      ],
      correctAnswer: 2
    },
    {
      id: 100158,
      question: "What does the SWOT acronym stand for in the material?",
      options: [
        "Sales, wages, operations, and taxes",
        "Strengths, weaknesses, opportunities, and threats",
        "Staffing, wages, opportunities, and training",
        "Skills, wages, objectives, and threats"
      ],
      correctAnswer: 1
    },
    {
      id: 100159,
      question: "What should the Human Resources section of a business plan include, per the material?",
      options: [
        "Only the office's parking arrangements",
        "Only the company's social media handles",
        "Job descriptions, skills, and training required",
        "Only the founder's personal résumé"
      ],
      correctAnswer: 2
    },
    {
      id: 100160,
      question: "Which certificate is given as an example in the Social Responsibility Strategy section?",
      options: [
        "SWOT",
        "WHMIS",
        "ODHA",
        "HR"
      ],
      correctAnswer: 1
    },
    {
      id: 100161,
      question: "Which of the following are examples of an E-business Strategy, per the material?",
      options: [
        "Printed brochures and radio advertisements",
        "In-person cold calling only",
        "Newspaper classified advertisements only",
        "Website design and online booking or billing"
      ],
      correctAnswer: 3
    },
    {
      id: 100162,
      question: "What time span should Financial Forecasts cover, according to the material?",
      options: [
        "Three to five years, focused on the first 12 months",
        "Only the first single month of operation",
        "Ten to fifteen years overall",
        "Only the founding year's tax return"
      ],
      correctAnswer: 0
    },
    {
      id: 100163,
      question: "According to the material, what can independent dental hygienists do with access to insurance companies?",
      options: [
        "Set national dental hygiene wages",
        "Submitting insurance claims for clients",
        "Approve dental hygiene business loans",
        "Certify dental equipment suppliers"
      ],
      correctAnswer: 1
    },
    {
      id: 100164,
      question: "Which organization is mentioned as having a fee guide for independent dental hygiene practitioners?",
      options: [
        "The Canadian Dental Association",
        "The Ontario Ministry of Health",
        "The Ontario Dental Hygiene Association",
        "The Canadian Revenue Agency"
      ],
      correctAnswer: 2
    },
    {
      id: 100165,
      question: "According to the material, what is described as the hardest part of the business plan for students?",
      options: [
        "The location for rental or ownership",
        "The color of the reception area walls",
        "The brand of computer used",
        "The style of staff uniforms"
      ],
      correctAnswer: 0
    },
    {
      id: 100166,
      question: "Which options are given for the type of business collaboration in the Finances section?",
      options: [
        "Only ever collaborating with a dentist",
        "Only ever working entirely alone",
        "Only ever franchising an existing brand",
        "Collaborating with a dentist or working alone"
      ],
      correctAnswer: 3
    },
    {
      id: 100167,
      question: "What should a Business Exit Strategy consider, according to the material?",
      options: [
        "How to hire more clinical staff",
        "How to design a new website",
        "How to update equipment yearly",
        "When to leave and how to value the business"
      ],
      correctAnswer: 3
    },
    {
      id: 100168,
      question: "How is ethics defined in the material's ethical challenge section?",
      options: [
        "A list of tax regulations",
        "A set of moral principles",
        "A schedule of client appointments",
        "A summary of marketing techniques"
      ],
      correctAnswer: 1
    },
    {
      id: 100169,
      question: "According to the material, what should all members of a group do when reviewing a business plan?",
      options: [
        "Only one member reviewing the plan",
        "Skipping sections written by others",
        "All group members reading the entire plan",
        "Submitting the plan without any review"
      ],
      correctAnswer: 2
    },
    {
      id: 100170,
      question: "Which of the following is listed as a reason small businesses fail?",
      options: [
        "Poor market research",
        "Excessive profit in the first year",
        "Overwhelming client loyalty",
        "Too much positive word-of-mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 100171,
      question: "According to the material, a business owner tends to micromanage while an entrepreneur tends to delegate.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100172,
      question: "The material states that a mission statement identifies the long-term goals of a business while a vision statement identifies its purpose and ethics.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100173,
      question: "The Executive Summary should be written last and should not exceed two pages.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100174,
      question: "According to the material, financial forecasts in a business plan typically cover only the first month of operation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100175,
      question: "The Ontario Dental Hygiene Association (ODHA) provides a fee guide for independent dental hygiene practitioners.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100176,
      question: "According to the material, procrastination and poor customer service are not listed as reasons small businesses fail.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "1. Business Practice (Part 4)": [
    {
      id: 100177,
      question: "What does the acronym FDHRC stand for?",
      options: [
        "Federation of Dental Hygiene Regulators of Canada",
        "Federal Dental Health Registry of Canada",
        "Federation of Dental Health Research Councils",
        "Foundation for Dental Hygiene Reform in Canada"
      ],
      correctAnswer: 0
    },
    {
      id: 100178,
      question: "What is the primary mission of the FDHRC?",
      options: [
        "To fund research grants for dental hygiene education programs",
        "To provide national leadership in dental hygiene regulation for the protection of the public",
        "To negotiate salary standards for dental hygienists nationally",
        "To operate continuing education courses for dental hygienists"
      ],
      correctAnswer: 1
    },
    {
      id: 100179,
      question: "Which organization completed the project to develop the Entry-to-Practice Canadian Competencies for Dental Hygienists?",
      options: [
        "Canadian Dental Hygienists Association",
        "National Dental Hygiene Certification Board",
        "CamProf Inc.",
        "Commission on Dental Accreditation of Canada"
      ],
      correctAnswer: 2
    },
    {
      id: 100180,
      question: "What does the acronym ADPIE stand for in the dental hygiene process of care?",
      options: [
        "Analysis, Development, Practice, Instruction, and Examination",
        "Assessment, Documentation, Prevention, Intervention, and Education",
        "Application, Diagnosis, Prescription, Instruction, and Evaluation",
        "Assessment, Diagnosis, Planning, Implementation, and Evaluation"
      ],
      correctAnswer: 3
    },
    {
      id: 100181,
      question: "How many entry-to-practice competencies are described in this document?",
      options: [
        "22",
        "15",
        "18",
        "25"
      ],
      correctAnswer: 0
    },
    {
      id: 100182,
      question: "How many domains are the dental hygiene competencies organized into?",
      options: [
        "Five",
        "Seven",
        "Six",
        "Eight"
      ],
      correctAnswer: 1
    },
    {
      id: 100183,
      question: "Which of the following is NOT one of the seven domains of expertise for dental hygienists in Canada?",
      options: [
        "Practice Management",
        "Clinical Therapy",
        "Financial Auditing",
        "Collaboration"
      ],
      correctAnswer: 2
    },
    {
      id: 100184,
      question: "In December 2015, which body published a report containing 94 Calls to Action referenced in this competency profile?",
      options: [
        "The Canadian Human Rights Commission",
        "The World Health Organization",
        "The Assembly of First Nations Health Board",
        "The Truth and Reconciliation Commission of Canada"
      ],
      correctAnswer: 3
    },
    {
      id: 100185,
      question: "According to the document, the term 'Indigenous peoples' includes which groups?",
      options: [
        "First Nations, Métis, and Inuit peoples",
        "Only First Nations peoples",
        "Only status Indians under federal legislation",
        "Métis and Inuit peoples only"
      ],
      correctAnswer: 0
    },
    {
      id: 100186,
      question: "What framework is used to describe the degrees of mastery for knowledge and skills in this document?",
      options: [
        "The CanMEDS Framework",
        "Bloom's Trajectory",
        "Maslow's Hierarchy of Human Needs",
        "The Ottawa Charter Model"
      ],
      correctAnswer: 1
    },
    {
      id: 100187,
      question: "Each competency in the profile is defined using what type of statement?",
      options: [
        "A lengthy narrative describing a hygienist's entire career path",
        "A numerical score representing years of experience required",
        "A short action statement describing what a dental hygienist must be able to perform",
        "A legal clause referencing provincial licensing acts"
      ],
      correctAnswer: 2
    },
    {
      id: 100188,
      question: "Which section of the document details the behaviours required for proficiency and to be assessed for each competency?",
      options: [
        "The bibliography",
        "The collaborators list",
        "The table of contents",
        "The performance criteria"
      ],
      correctAnswer: 3
    },
    {
      id: 100189,
      question: "Domain A, Professionalism, primarily focuses on dental hygienists' commitment to what?",
      options: [
        "The health of the public and the profession through ethical standards and legislative requirements",
        "Maximizing clinic revenue through efficient scheduling",
        "Marketing dental hygiene services to new clients",
        "Reducing appointment wait times in private practice"
      ],
      correctAnswer: 0
    },
    {
      id: 100190,
      question: "Which performance criterion falls under competency A.1, Exhibit professional behaviour?",
      options: [
        "Conduct a community needs assessment",
        "Manage conflicts of interest",
        "Fabricate sports mouthguards",
        "Prepare comprehensive health records"
      ],
      correctAnswer: 1
    },
    {
      id: 100191,
      question: "Competency A.2 focuses on demonstrating a commitment to what?",
      options: [
        "Entrepreneurial activities",
        "Written communication",
        "Serving society",
        "Clinical diagnosis"
      ],
      correctAnswer: 2
    },
    {
      id: 100192,
      question: "Which performance criterion belongs to competency A.3, Integrate professional responsibilities into practice?",
      options: [
        "Develop a business plan based on a service delivery model",
        "Assess people's circumstances and readiness to learn",
        "Perform periodontal therapy",
        "Maintain privacy, confidentiality, and security"
      ],
      correctAnswer: 3
    },
    {
      id: 100193,
      question: "Competency A.4 addresses which ongoing professional obligation?",
      options: [
        "A commitment to lifelong learning",
        "A commitment to entrepreneurial growth",
        "A commitment to advanced clinical surgery",
        "A commitment to national policy advocacy"
      ],
      correctAnswer: 0
    },
    {
      id: 100194,
      question: "Domain B, Evidence-Informed Practice, is built on which core commitment?",
      options: [
        "Strict adherence to seniority-based promotion in clinics",
        "Excellence in practice through critical thinking, continuous learning, and evidence-informed decision-making",
        "Reliance solely on personal clinical experience over research",
        "Delegating all diagnostic decisions to dentists"
      ],
      correctAnswer: 1
    },
    {
      id: 100195,
      question: "Which competency involves exploring complex issues from many points of view and managing ambiguity?",
      options: [
        "C.1 Demonstrate effective oral and non-verbal communication",
        "E.1 Fulfill administrative responsibilities",
        "B.1 Demonstrate critical thinking, problem-solving, and reasoning skills",
        "G.1 Assess oral and general health status"
      ],
      correctAnswer: 2
    },
    {
      id: 100196,
      question: "Competency B.3 concerns which activity?",
      options: [
        "Coordinating client appointments and schedules",
        "Fabricating whitening trays and mouthguards",
        "Managing conflicts of interest with clients",
        "Using various methods of inquiry, including participating in research activities"
      ],
      correctAnswer: 3
    },
    {
      id: 100197,
      question: "Domain C, Communication, emphasizes forming relationships to facilitate what?",
      options: [
        "The gathering and sharing of essential information for culturally safe and relevant care",
        "The negotiation of employment contracts",
        "The development of new dental hygiene instruments",
        "The scheduling of continuing education courses"
      ],
      correctAnswer: 0
    },
    {
      id: 100198,
      question: "According to competency C.1, in addition to an official language, oral proficiency in which type of language may be a supplementary competence?",
      options: [
        "A second official European language",
        "An Indigenous language",
        "Medical Latin terminology",
        "Sign language for all clients"
      ],
      correctAnswer: 1
    },
    {
      id: 100199,
      question: "Which performance criterion belongs under C.2, Use written communication effectively?",
      options: [
        "Work with cultural brokers or interpreters when indicated",
        "Engage in mentorship activities",
        "Prepare comprehensive and accurate health records",
        "Develop realistic and measurable goals related to oral health"
      ],
      correctAnswer: 2
    },
    {
      id: 100200,
      question: "Domain D, Collaboration, positions dental hygienists as what within the health care team?",
      options: [
        "Independent contractors who operate without any team involvement",
        "Supervisors who direct the work of dentists",
        "Administrative staff responsible only for billing",
        "Integral members working in partnership with others to provide person-, family-, and community-centred care"
      ],
      correctAnswer: 3
    },
    {
      id: 100201,
      question: "Which performance criterion is listed under D.1, Collaborate with people accessing dental hygiene services?",
      options: [
        "Promote individual and community autonomy and self-determination",
        "Use conflict management strategies as required with colleagues",
        "Implement current infection prevention and control measures",
        "Access reliable sources of information"
      ],
      correctAnswer: 0
    },
    {
      id: 100202,
      question: "Competency D.2 focuses on collaboration with whom?",
      options: [
        "Only clients and their immediate family",
        "Oral health professionals and others",
        "Only regulatory bodies and government agencies",
        "Only other dental hygienists in the same clinic"
      ],
      correctAnswer: 1
    },
    {
      id: 100203,
      question: "Domain E, Practice Management, involves organization, administration, and decision-making that facilitates what?",
      options: [
        "Maximum client volume regardless of care quality",
        "Elimination of all administrative recordkeeping",
        "High-quality care, efficient use of time and personnel, and enhanced satisfaction",
        "Replacement of clinical staff with automated systems"
      ],
      correctAnswer: 2
    },
    {
      id: 100204,
      question: "Which performance criterion is found under E.1, Fulfill administrative responsibilities?",
      options: [
        "Perform comprehensive oral health examinations",
        "Explore advocacy approaches for oral health issues",
        "Discuss the care plan with appropriate people",
        "Coordinate appointments"
      ],
      correctAnswer: 3
    },
    {
      id: 100205,
      question: "Competency E.3, Engage in entrepreneurial activities, includes which performance criterion?",
      options: [
        "Develop a business plan based on a chosen service delivery model",
        "Obtain radiographs as needed",
        "Promote teamwork and partnerships",
        "Use social marketing techniques appropriately"
      ],
      correctAnswer: 0
    },
    {
      id: 100206,
      question: "Domain F, Prevention, Education, and Health Promotion, embraces what kind of approach to health and wellness?",
      options: [
        "A strictly clinical, treatment-only approach",
        "An inclusive and intercultural approach",
        "An approach limited to pediatric populations",
        "An approach focused solely on cosmetic outcomes"
      ],
      correctAnswer: 1
    },
    {
      id: 100207,
      question: "Which performance criterion is listed under F.1, Lead the development of health literacy and oral self-care abilities?",
      options: [
        "Conduct a community needs assessment",
        "Facilitate change and innovation",
        "Develop learning plans based on identified needs",
        "Monitor responses to care"
      ],
      correctAnswer: 2
    },
    {
      id: 100208,
      question: "Competency F.3 focuses on advocacy to address what?",
      options: [
        "Staffing shortages in dental clinics",
        "Insurance billing disputes",
        "Equipment procurement costs",
        "Oral health inequities"
      ],
      correctAnswer: 3
    },
    {
      id: 100209,
      question: "Domain G, Clinical Therapy, involves the provision of what kinds of dental hygiene care?",
      options: [
        "Preventive, therapeutic, and supportive care",
        "Only cosmetic and elective care",
        "Only emergency and surgical care",
        "Only administrative and record-based care"
      ],
      correctAnswer: 0
    },
    {
      id: 100210,
      question: "Which performance criterion belongs to competency G.1, Assess oral and general health status?",
      options: [
        "Develop diagnostic statements",
        "Evaluate clients' vital signs as they relate to dental hygiene practice",
        "Refer to the appropriate professional or agency",
        "Provide recommendations for continuing care"
      ],
      correctAnswer: 1
    },
    {
      id: 100211,
      question: "Competency G.2 requires dental hygienists to do what?",
      options: [
        "Create a dental hygiene care plan",
        "Implement the dental hygiene care plan",
        "Formulate a dental hygiene diagnosis",
        "Evaluate effectiveness of dental hygiene care"
      ],
      correctAnswer: 2
    },
    {
      id: 100212,
      question: "According to the clarifications, a care plan is informed by which three elements?",
      options: [
        "The clinic's revenue targets, staff schedules, and insurance policies",
        "The dentist's final approval, government regulations, and lab test results",
        "The client's payment history, referral source, and appointment frequency",
        "The dental hygiene diagnosis, best available evidence, and the needs and preferences of the client"
      ],
      correctAnswer: 3
    },
    {
      id: 100213,
      question: "Under competency G.4, fabrication of whitening trays is considered what in Quebec?",
      options: [
        "A reserved act requiring demonstrated competence",
        "A task prohibited for all dental hygienists",
        "An activity requiring dentist supervision only in Quebec",
        "A skill not included in any provincial regulation"
      ],
      correctAnswer: 0
    },
    {
      id: 100214,
      question: "Which performance criterion is part of G.5, Evaluate effectiveness of dental hygiene care?",
      options: [
        "Perform comprehensive oral health examinations",
        "Obtain feedback on services provided and outcomes achieved",
        "Determine contraindications to dental hygiene care",
        "Discuss the diagnosis with others as appropriate"
      ],
      correctAnswer: 1
    },
    {
      id: 100215,
      question: "According to the clarifications section, how is 'accountability' defined?",
      options: [
        "Maintaining detailed financial records for a dental practice",
        "Following the instructions of a supervising dentist without question",
        "Accepting responsibility for one's actions, including to those served and to society",
        "Reporting only positive outcomes to regulatory bodies"
      ],
      correctAnswer: 2
    },
    {
      id: 100216,
      question: "How does the document define 'cultural humility'?",
      options: [
        "A formal certification earned through continuing education courses",
        "A legal requirement to speak multiple languages fluently",
        "A marketing strategy used to attract diverse clientele",
        "A process of self-reflection to understand personal and systemic conditioned biases and build respectful relationships"
      ],
      correctAnswer: 3
    },
    {
      id: 100217,
      question: "How is 'cultural safety' described in the clarifications?",
      options: [
        "An outcome of respectful engagement that addresses power imbalances and results in an environment free of racism and discrimination",
        "A physical safety protocol for infection control in the clinic",
        "A legal waiver signed by clients before treatment",
        "A staffing policy ensuring diverse hiring practices"
      ],
      correctAnswer: 0
    },
    {
      id: 100218,
      question: "Who or what is included in the definition of 'client(s)' in this document, citing CDHA 2002?",
      options: [
        "Only individual paying patients seen in a private practice",
        "An individual, family, group, organization, or community accessing the professional services of a dental hygienist",
        "Only government agencies contracting dental hygiene services",
        "Only dentists who refer patients to a dental hygienist"
      ],
      correctAnswer: 1
    },
    {
      id: 100219,
      question: "How is 'diagnosis' defined in the clarifications section, citing Bowen & Pieren, 2020?",
      options: [
        "A legally binding document requiring a dentist's signature",
        "A billing code submitted to an insurance provider",
        "The use of critical decision-making skills to reach and communicate conclusions about a client's dental hygiene needs",
        "A checklist completed after treatment is finished"
      ],
      correctAnswer: 2
    },
    {
      id: 100220,
      question: "What is 'Jordan's Principle,' as defined in the document?",
      options: [
        "A billing standard used across Canadian dental clinics",
        "A rule requiring dentists to co-sign all hygienist diagnoses",
        "A national standard for dental hygiene curriculum length",
        "A child-first principle ensuring substantive equality and no gaps in publicly funded services for First Nations children"
      ],
      correctAnswer: 3
    },
    {
      id: 100221,
      question: "According to the Ottawa Charter for Health Promotion (1986), how many key strategies for health promotion are described?",
      options: [
        "Five",
        "Three",
        "Seven",
        "Four"
      ],
      correctAnswer: 0
    },
    {
      id: 100222,
      question: "Which of these is one of the five key strategies from the Ottawa Charter for Health Promotion cited in the document?",
      options: [
        "Increase clinic profit margins",
        "Build healthy public policy",
        "Standardize national licensing exams",
        "Expand private insurance coverage"
      ],
      correctAnswer: 1
    },
    {
      id: 100223,
      question: "How does the document define 'informed consent'?",
      options: [
        "A signature obtained solely for insurance billing purposes",
        "A verbal agreement that treatment costs will be paid in full",
        "Providing information about a proposed treatment, including risks, alternatives, and consequences of no treatment, to support decision-making",
        "A form used only when treating minors without exception"
      ],
      correctAnswer: 2
    },
    {
      id: 100224,
      question: "What does 'fitness to practice' refer to, according to the clarifications?",
      options: [
        "A physical fitness test required annually for licensure",
        "The number of continuing education credits completed each year",
        "A hygienist's years of clinical experience",
        "The qualities and capabilities relevant to a hygienist's capacity to practise, including freedom from impairing conditions"
      ],
      correctAnswer: 3
    },
    {
      id: 100225,
      question: "How is 'governability' defined in the document?",
      options: [
        "The ability to govern oneself as an autonomous professional while complying with regulatory standards",
        "The capacity of a regulatory body to enforce criminal law",
        "The process by which a business obtains a municipal operating license",
        "A dentist's authority over a hygienist's clinical decisions"
      ],
      correctAnswer: 0
    },
    {
      id: 100226,
      question: "Which of the following is included in the definition of 'determinants of health' in this document?",
      options: [
        "Only genetic and hereditary factors",
        "Social, cultural, biological, physical, and economic environments",
        "Only access to private dental insurance",
        "Only a person's age and occupation"
      ],
      correctAnswer: 1
    },
    {
      id: 100227,
      question: "According to the clarifications, what does 'periodontal therapy' include?",
      options: [
        "Only surgical extraction of teeth",
        "Only orthodontic bracket placement",
        "Nonsurgical periodontal therapy, periodontal debridement, and management of peri-implant tissues",
        "Only administration of general anesthesia"
      ],
      correctAnswer: 2
    },
    {
      id: 100228,
      question: "How is 'person-, family-, and community-centred' care described?",
      options: [
        "Prioritizing the fastest possible treatment time above all else",
        "Focusing exclusively on the client's insurance provider requirements",
        "Delegating all care decisions to a family member regardless of client wishes",
        "Focusing on the whole person as a unique individual, not just on their illness or disease"
      ],
      correctAnswer: 3
    },
    {
      id: 100229,
      question: "What does 'professional distance' refer to in the clarifications?",
      options: [
        "An obligation to ensure a professional relationship isn't compromised by prioritizing one's own needs over the client's",
        "The physical distance maintained between a hygienist and client during treatment",
        "A rule limiting how many years a hygienist may treat the same client",
        "The geographic distance between a clinic and its regulatory college"
      ],
      correctAnswer: 0
    },
    {
      id: 100230,
      question: "How does the document define 'social justice'?",
      options: [
        "The right of a hygienist to set their own fees without regulation",
        "Fair and equitable distribution of resources, including health services, among groups in society",
        "A legal defense used in malpractice cases",
        "A requirement that all clinics operate as non-profit organizations"
      ],
      correctAnswer: 1
    },
    {
      id: 100231,
      question: "What are 'vital signs,' as clarified in the document?",
      options: [
        "Height, weight, and body mass index",
        "Visual acuity, hearing, and reflexes",
        "Blood pressure, pulse, respiratory rate, and body temperature",
        "Blood glucose, cholesterol, and hemoglobin levels"
      ],
      correctAnswer: 2
    },
    {
      id: 100232,
      question: "The domains of expertise diagram in this document was adapted from which framework?",
      options: [
        "The World Health Organization's Health Promotion Model",
        "The Maslow Hierarchy of Human Needs Diagram",
        "The National Interprofessional Competency Framework Wheel",
        "The CanMEDS Physician Competency Diagram"
      ],
      correctAnswer: 3
    },
    {
      id: 100233,
      question: "Which knowledge area is listed under Domain A (Professionalism) in Appendix A?",
      options: [
        "Conflicts of interest",
        "Research paradigms",
        "Inventory systems",
        "Local anaesthesia"
      ],
      correctAnswer: 0
    },
    {
      id: 100234,
      question: "Which knowledge area is listed under Domain B (Evidence-Informed Practice) in Appendix A?",
      options: [
        "Contracts",
        "Critical appraisal tools",
        "Biofilm control",
        "Vital signs"
      ],
      correctAnswer: 1
    },
    {
      id: 100235,
      question: "Which knowledge area is listed under Domain D (Collaboration) in Appendix A?",
      options: [
        "Bookkeeping and accounting",
        "Radiography",
        "Team functioning, group dynamics and processes",
        "Data and thematic analysis"
      ],
      correctAnswer: 2
    },
    {
      id: 100236,
      question: "Which knowledge area is listed under Domain E (Practice Management) in Appendix A?",
      options: [
        "Periodontal probing",
        "Research ethics",
        "Cultural safety and humility",
        "Billing practices"
      ],
      correctAnswer: 3
    },
    {
      id: 100237,
      question: "Which knowledge area is listed under Domain F (Prevention, Education, and Health Promotion) in Appendix A?",
      options: [
        "Principles of change and stages of behaviour change",
        "Organizational theory",
        "Clinical attachment levels",
        "Contractual agreements"
      ],
      correctAnswer: 0
    },
    {
      id: 100238,
      question: "Which diagnostic model is referenced under competency G.2 in Appendix A?",
      options: [
        "The Ottawa Charter Model",
        "Maslow's Hierarchy of Human Needs and the Dental Hygiene Human Needs Conceptual Model",
        "The CanMEDS Framework",
        "Bloom's Trajectory"
      ],
      correctAnswer: 1
    },
    {
      id: 100239,
      question: "In Bloom's Trajectory, what does the knowledge level K1 represent?",
      options: [
        "Creating — building new patterns, concepts, or systems",
        "Evaluating — making judgments about the value of ideas",
        "Remembering — knowing 'what' and recalling data, information, rules, or definitions",
        "Analyzing — separating material into component parts"
      ],
      correctAnswer: 2
    },
    {
      id: 100240,
      question: "In Bloom's Trajectory, what does the knowledge level K3, Applying, represent?",
      options: [
        "Recalling facts or definitions without further interpretation",
        "Weighing up ideas and making a judgment on their value",
        "Bringing information together to create something new",
        "Knowing how to use a concept in a new situation, such as putting theory into practical effect"
      ],
      correctAnswer: 3
    },
    {
      id: 100241,
      question: "In Bloom's Trajectory, what is the highest knowledge level, K6?",
      options: [
        "Creating — bringing information together to form something new, such as new models or systems",
        "Understanding — translating and interpreting instructions",
        "Remembering — quoting rules and definitions",
        "Applying — using a concept in a novel workplace situation"
      ],
      correctAnswer: 0
    },
    {
      id: 100242,
      question: "In the Skills Domain of Bloom's Trajectory, what does S3, Basic proficiency, describe?",
      options: [
        "'Conscious incompetence,' representing a complete lack of awareness",
        "'Conscious competence,' where learned responses have become habitual with only a few minor errors",
        "Expert-level performance requiring no conscious thought",
        "The ability to invent entirely new procedures for novel situations"
      ],
      correctAnswer: 1
    },
    {
      id: 100243,
      question: "What is the highest skills level in Bloom's Trajectory, S6?",
      options: [
        "Readiness — recognizing one's abilities and limitations",
        "Attempting — imitating and practising a complex skill",
        "Creative proficiency — creating new routines or techniques to fit a particular situation",
        "Full proficiency — performing complex patterns with minimum energy"
      ],
      correctAnswer: 2
    },
    {
      id: 100244,
      question: "According to Appendix B, what minimum level of knowledge and skill proficiency is illustrated as an example for competency D.2?",
      options: [
        "K6 and S6",
        "K1 and S1",
        "K5 and S4",
        "K3 and S3"
      ],
      correctAnswer: 3
    },
    {
      id: 100245,
      question: "Which reference text is cited as a key source for definitions such as 'care plan' and 'diagnosis' throughout the document?",
      options: [
        "Darby and Walsh Dental Hygiene: Theory and Practice by Bowen & Pieren (2020)",
        "The CanMEDS 2015 Physician Competency Framework by Frank, Snell, and Sherbino",
        "Core Competencies for Public Health in Canada by the Public Health Agency of Canada",
        "Determinants of Indigenous Peoples' Health in Canada by Greenwood et al. (2018)"
      ],
      correctAnswer: 0
    },
    {
      id: 100246,
      question: "In what month and year was this Entry-to-Practice Canadian Competencies for Dental Hygienists document published?",
      options: [
        "January 2022",
        "November 2021",
        "March 2020",
        "September 2021"
      ],
      correctAnswer: 1
    },
    {
      id: 100247,
      question: "The FDHRC is composed of organizations that have a statutory responsibility to regulate the profession of dental hygiene within their respective provinces.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100248,
      question: "The Entry-to-Practice Canadian Competencies for Dental Hygienists document organizes its 22 competencies into five domains.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100249,
      question: "The ADPIE process of care stands for Assessment, Diagnosis, Planning, Implementation, and Evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100250,
      question: "According to the document, fabrication of whitening trays is a reserved act in Quebec, requiring demonstrated competence.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100251,
      question: "The domains of expertise diagram in this document was adapted from the Ottawa Charter for Health Promotion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 100252,
      question: "Cultural safety is described as an outcome that results in an environment free of racism and discrimination in health care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 100253,
      question: "Bloom's Trajectory has separate levels only for the Knowledge domain and does not describe a Skills domain.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
